import { css } from 'styled-components';
import { PriceComponent } from '../components/common';
import {
  DescriptionComponent,
  InfoCaption,
  InfoTitle,
  ItemFooterText,
  ItemLayoutOneNameContainer,
  NameComponent,
  SectionsTitleComponent
} from '../components/menu/menu-layouts';

type ColorProps = {
  colorScheme: string;
  backgroundColor: string;
  textColor: string;
  menuColor: string;
  sectionColor: string;
  accentColor: string;
};

export const colors = (props: ColorProps) => {
  const {
    colorScheme,
    backgroundColor,
    textColor,
    menuColor,
    sectionColor,
    accentColor
  } = props;

  if (colorScheme === 'dark') {
    return css`
      background-color: #000;

      ${InfoTitle} {
        color: ${accentColor || '#fff'};

        &::before,
        &::after {
          background-color: ${accentColor || '#fff'};
        }
      }

      ${ItemFooterText},
      ${DescriptionComponent},
      ${PriceComponent},
      ${NameComponent},
      ${InfoCaption} {
        color: #fff;
      }

      ${SectionsTitleComponent} {
        color: ${accentColor || '#fff'};
      }

      ${ItemLayoutOneNameContainer} {
        &::after {
          background-image: linear-gradient(
            to right,
            white 22%,
            rgba(0, 0, 0, 0) 0%
          );
        }
      }
    `;
  }

  if (colorScheme === 'light') {
    return css`
      background-color: #fff;

      ${InfoTitle} {
        color: ${accentColor || '#111'};

        &::before,
        &::after {
          background-color: ${accentColor || '#111'};
        }
      }

      ${ItemFooterText},
      ${DescriptionComponent},
      ${PriceComponent},
      ${NameComponent},
      ${InfoCaption} {
        color: #111;
      }

      ${SectionsTitleComponent} {
        color: ${accentColor || '#111'};
      }

      ${ItemLayoutOneNameContainer} {
        &::after {
          background-image: linear-gradient(
            to right,
            black 22%,
            rgba(255, 255, 255, 0) 0%
          );
        }
      }
    `;
  }

  if (colorScheme === 'custom') {
    return css`
      background-color: ${backgroundColor};

      ${InfoTitle} {
        color: ${menuColor || accentColor || textColor};

        &::before,
        &::after {
          background-color: ${menuColor || accentColor || textColor};
        }
      }

      ${ItemFooterText},
      ${DescriptionComponent},
      ${PriceComponent},
      ${NameComponent},
      ${InfoCaption} {
        color: ${textColor};
      }

      ${SectionsTitleComponent} {
        color: ${sectionColor || accentColor || textColor};
      }

      ${ItemLayoutOneNameContainer} {
        &::after {
          background-image: linear-gradient(
            to right,
            ${textColor} 22%,
            rgba(255, 255, 255, 0) 0%
          );
        }
      }
    `;
  }

  return css`
    background-color: transparent;
  `;
};
